import { formatDateTime } from '@seen/core/dates'
import type * as appointments from '@seen/core/models/appointments/index'
import { DotSeparator } from '@seen/ui'
import { Fragment, type JSX } from 'react'
import { HoverPractitioner } from '#src/components/core/hover-card/HoverPractitioner.tsx'
import { TextLink } from '#src/components/core/TextLink.tsx'
import { useCreatedOn } from '#src/hooks/useCreatedOn.ts'
import { TimelineTextEntry } from '#src/pages/participants/timeline/TimelineTextEntry.tsx'
import { buildAppointmentRelativeUrl } from '#src/stores/calendar.ts'

export function AppointmentTimelineItem({
  appointment,
}: {
  appointment: appointments.ExtendedAppointment
}): JSX.Element {
  const { data: createdOn } = useCreatedOn(appointment.reference)
  return (
    <TimelineTextEntry
      actor={appointment.lastUpdatedBy}
      time={appointment.lastUpdated}
      action={
        <>
          {createdOn === appointment.lastUpdated ? 'created' : 'updated'}{' '}
          appointment{' '}
          <TextLink to={buildAppointmentRelativeUrl(appointment)}>
            {appointment.title}{' '}
            {appointment.start && (
              <>
                {' @ '}
                {formatDateTime(appointment.start)}
              </>
            )}
          </TextLink>{' '}
          with{' '}
          {appointment.practitioners.map((p, index) => (
            <Fragment key={p.reference}>
              {index > 0 && ' & '}
              <HoverPractitioner practitioner={p} />
            </Fragment>
          ))}
          <DotSeparator />
          {appointment.status}
        </>
      }
      reference={appointment.reference}
      originTask={appointment.queuedEditsOriginTask}
    />
  )
}
